import { Autocomplete } from '@mui/material';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Controller, Control, FieldValues, FieldPath } from 'react-hook-form';
import { TIMEZONES } from 'shared/mui/DatePicker/constants/timezones';
import { TextField } from 'shared/mui/TextField/TextField';

type Timezone = {
  name: string;
  offset: string;
};

type TimezoneSelectFieldProps<T extends FieldValues = FieldValues> = {
  control: Control<T>;
  name: FieldPath<T>;
  label?: string;
  disabled?: boolean;
};

export const TimezoneSelectField = <T extends FieldValues = FieldValues>({
  control,
  name,
  label,
  disabled,
}: TimezoneSelectFieldProps<T>) => {
  const translate = useTypedTranslate();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          disabled={disabled}
          fullWidth
          getOptionLabel={(option: Timezone) => `${option.name} (${option.offset})`}
          isOptionEqualToValue={(option, value) => option?.name === value?.name}
          onChange={(_, newValue) => onChange(newValue)}
          options={TIMEZONES}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label || translate('app.datePicker.timezone')}
              size="small"
              variant="outlined"
            />
          )}
          value={value}
        />
      )}
    />
  );
};
